var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0000610352,
    width: 9.99931,
    height: 9.99997,
    rx: 4.99965,
    fill: "#FFF6E5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99972 0C2.23848 0 6.10352e-05 2.23875 6.10352e-05 4.99998C6.10352e-05 5.06696 0.0013779 5.13362 0.00398716 5.19996C0.108954 2.53141 2.30546 0.399948 4.99972 0.399948C7.69397 0.399948 9.89048 2.53141 9.99544 5.19996C9.99805 5.13362 9.99937 5.06696 9.99937 4.99998C9.99937 2.23875 7.76095 0 4.99972 0Z",
    fill: "#CACACA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99964 9.99997C7.76088 9.99997 9.9993 7.76122 9.9993 4.99999C9.9993 4.93301 9.99798 4.86634 9.99537 4.8C9.8904 7.46854 7.6939 9.6 4.99964 9.6C2.30539 9.6 0.108889 7.46854 0.00391624 4.8C0.00130698 4.86634 -1.00475e-05 4.93301 -1.00533e-05 4.99999C-1.02947e-05 7.76122 2.23841 9.99997 4.99964 9.99997Z",
    fill: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60281 4.96929L4.99914 2.50005L3.39422 4.97121C3.22291 5.22273 3.1243 5.51775 3.1243 5.83324C3.1243 6.75374 3.96371 7.49995 4.99917 7.49995C6.03463 7.49995 6.87404 6.75374 6.87404 5.83324C6.87404 5.51694 6.77493 5.22123 6.60281 4.96929Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 4.99917,
    y1: 2.50005,
    x2: 4.99917,
    y2: 7.49993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56CCF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D9CDB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaticon);
export default __webpack_public_path__ + "static/media/heat icon.3557d952e73556f8cfede45654e68f1f.svg";
export { ForwardRef as ReactComponent };